export default __webpack_public_path__ + "static/media/menadd.7c2d9d79.jpg";